export default __webpack_public_path__ + "static/media/SG22.6fe03905.png";